import { ArrayBase } from '../../ArrayBase'
import { isEmpty } from 'lodash/fp'
import { Ignore } from '@master/annotation/Ignore'
import { IClientOptions, IAssuredOptions, FormOptions } from '../FormOptions'
import { MaxChar } from '@master/annotation/MaxChar'
import { IExistingPortfolio } from './IExistingPortfolio'
import { isSummaryField, SummaryField } from '@master/annotation/SummaryField'

export default class ExistingPortfolio extends ArrayBase implements IExistingPortfolio {
  type = 'existing portfolio'

  @MaxChar(20)
  companyName = ''

  owner: keyof IClientOptions = ''
  policyInsured: keyof IAssuredOptions = ''
  policyType = '' // JPara specific

  @MaxChar(52)
  policyName = ''

  @SummaryField('AP')
  premium = undefined

  @MaxChar(20)
  policyTerms = ''

  date?: number = null

  @SummaryField('DP')
  lifeProtection?: number = null

  @SummaryField('TPD')
  disabilityProtection?: number = null

  disabilityIncome?: number = null

  @SummaryField('PA')
  accidentProtection?: number = null

  @SummaryField('CIP')
  criticalIllnessProtection?: number = null

  @SummaryField('R&B')
  roomAndBoard?: number = null

  @SummaryField('H&S')
  hospitalIncome?: number = null

  roomBoardHospitalIncome = ''
  others?: number = null // JPara specific

  @SummaryField('Maturity Value (MV)')
  maturityValue?: number = null

  maturityAge?: number = null

  @MaxChar(36)
  remarks = ''

  @Ignore()
  formOptions?: FormOptions

  constructor (formOptions: FormOptions = null) {
    super()
    this.formOptions = formOptions
    this.startIndex = 1
  }

  getSummaryFields (): { attrName: string; abbre: string }[] {
    const summaryFields: { attrName: string; abbre: string }[] = []
    Object.keys(this).forEach(attr => {
      const grabSummaryField = isSummaryField(this, attr)
      if (grabSummaryField) {
        summaryFields.push({
          attrName: attr,
          ...grabSummaryField
        })
      }
    })
    return summaryFields
  }

  isValid () {
    return !isEmpty(this.owner) && this.owner.length > 0
  }

  belongsTo (owner: 'C1' | 'C2') {
    return this.isValid() && this.policyInsured === owner
  }

  reset () {
    Object.keys(this).filter(key => {
      return key !== 'type' && key !== 'startIndex' && key !== 'formOptions' && key !== 'curIndex'
    }).forEach(key => {
      this[key] = null
    })
  }
}
